module.exports = __webpack_public_path__ + "static/media/18ECA31.95f3377d.jpg";